import { FunctionComponent } from "react";
import NAV from "../components/NAV";

const Lesson5: FunctionComponent = () => {
  return (
    <div className="relative [background:linear-gradient(111.77deg,_rgba(0,_0,_0,_0),_#363636_78.54%),_#0d0d0d] w-full overflow-hidden flex flex-col items-center justify-center p-[2.69rem] box-border gap-[6.88rem] text-left text-[1.56rem] text-darkgray font-nunito">
      <NAV />
      <div className="self-stretch flex flex-row items-center justify-between">
        <a className="cursor-pointer text-darkgray no-underline" href={"/lesson4"}>
          <div className="rounded-32xl bg-gainsboro-200 box-border w-[9.81rem] h-[3.5rem] flex flex-col items-end justify-start py-[0.69rem] px-[3rem] border-[1px] border-solid border-gray-200">
            <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
              Back
            </b>
          </div>
        </a>
        <div className="flex-1 flex flex-col items-center justify-center text-center text-[2.81rem] text-white">
          <b className="self-stretch relative leading-[120%] whitespace-pre-wrap">
            Stock Markets
          </b>
        </div>
        <a className="cursor-pointer text-darkgray no-underline" href={"/lesson6"}>
          <div className="rounded-32xl bg-gainsboro-200 box-border w-[9.81rem] h-[3.5rem] flex flex-col items-end justify-start py-[0.69rem] px-[3rem] border-[1px] border-solid border-gray-200">
            <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
              Next
            </b>
          </div>
        </a>
      </div>
      <div className="flex flex-col items-center justify-center gap-[10.06rem] w-[92%] mr-[4%] max-w-[110rem] text-justify text-[1.88rem] text-white font-dm-sans">
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>How to Invest in Stocks</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                Investing is a time-tested way of putting your money to work for
                you, as you work to earn more of it. Legendary investor Warren
                Buffett defined investing as “forgoing consumption now in order
                to have the ability to consume more at a later date.”1
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                By investing your money regularly, you may be able to increase
                it many times over with time. That's why it's important to begin
                investing as early as possible and as soon as you have some
                money saved for that purpose. Furthermore, the stock market is a
                good place to start.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Whether you have $1,000 set aside or can manage only an extra
                $25 a week, you can get started. Bear in mind that there's a lot
                that you can and should learn about investing in stocks to
                achieve financial success. However, right now, read on for the
                steps to begin the process.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>KEY TAKEAWAYS</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <ul className="m-0 text-[1rem] pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  Investing is the act of committing money or capital to an
                  endeavor with the expectation of obtaining additional income
                  or profit.
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  Unlike consuming, investing puts money to work so it can grow
                  over time.
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  However, investing also comes with the risk of losses.
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  The stock market is a common way for investors, no matter
                  their experience, to invest for a lifetime.
                </span>
              </span>
            </li>
            <li>
              <span>
                <span>
                  Beginning investors can get help from expert advisors, leave
                  their portfolio selection and management to robo-advisors, or
                  take a DIY approach to investing in stocks.
                </span>
              </span>
            </li>
          </ul>
        </div>
        <div className="self-stretch flex flex-col items-center justify-center text-center text-[2.81rem] font-nunito">
          <b className="relative">Steps To get Started</b>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>1. Define Your Tolerance for Risk</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <ul className="m-0 text-[1rem] pl-[2.06rem]">
            <li>
              <span>
                <span>
                  What's your tolerance for risk (the chance that you may lose
                  money while investing)? Stocks are categorized in various
                  ways, such as large capitalization stocks, small cap stocks,
                  aggressive growth stocks, and value stocks. They all have
                  different levels of risk. Once you determine your risk
                  tolerance, you can set your investment sights on the stocks
                  that complement it.
                </span>
              </span>
            </li>
          </ul>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.56rem]">
          <p className="m-0 text-[1.88rem]">
            <b>
              <span>2. Decide on Your Investment Goals</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                You should also determine your investment goals. When opening a
                brokerage account, an online broker such as Charles Schwab or
                Fidelity will ask you about your investment goals (and the
                aforementioned level of risk that you’re willing to take).
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  If you're just beginning your career, an investment goal could
                  be to increase the amount of money in your account. If you're
                  older, you may want to generate income as well as grow and
                  protect your wealth.
                </span>
              </span>
            </li>
            <li>
              <span>
                <span>
                  Your investment goals might include buying a house, funding
                  your retirement, or saving for tuition. Goals can change over
                  time. Just make sure that you define and review them
                  periodically so that you can keep your focus on achieving
                  them.
                </span>
              </span>
            </li>
          </ul>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.56rem]">
          <p className="m-0 text-[1.88rem]">
            <b>
              <span>3. Determine Your Investing Style</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Some investors want to take an active hand in managing their
                investments, while others prefer to set it and forget it. Your
                preference may change, but decide on an approach to get started.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  If you're confident about your investing knowledge and
                  capability, you could manage your investing and portfolio on
                  your own. Traditional online brokers, like the two mentioned
                  above, allow you to invest in stocks, bonds, exchange-traded
                  funds (ETFs), index funds, and mutual funds.
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  An experienced broker or financial advisor can help you make
                  your investment decisions, monitor your portfolio, and make
                  changes to it. This is a good option for beginners who
                  understand the importance of investing but may want an expert
                  to help them do it.
                </span>
              </span>
            </li>
            <li>
              <span>
                <span>
                  A robo-advisor is an automated, hands-off option that
                  typically costs less than working with a broker or financial
                  advisor. Once a robo-advisor program has your goals, risk
                  tolerance level, and other details, it automatically invests
                  for you.
                </span>
              </span>
            </li>
          </ul>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.56rem]">
          <p className="m-0 text-[1.88rem]">
            <b>
              <span>4. Choose Your Investment Account</span>
            </b>
          </p>
          <p className="m-0 text-[1.75rem] text-gainsboro-100">
            <span>
              <b>
                <span>&nbsp;</span>
              </b>
            </span>
          </p>
          <p className="m-0">
            <span>
              <b>
                <span>Retirement plan at work</span>
              </b>
              <span>
                : You can invest in various stock and bond mutual funds and
                target-date funds through a retirement plan at work, such as a
                401(k), if your employer offers one. It may also offer the
                option of investing in the employer's company stock.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Once you enroll in a plan, contributions are made automatically
                at a level you set. Employers may make matching contributions on
                your behalf. Your contributions are tax deductible and your
                account balance grows tax deferred. This is a great way to
                maximize your investing dollars with little effort. It can also
                instill in investors the discipline of regular investing.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <b className="text-[1.75rem] font-dm-sans">
                An IRA or taxable account at a brokerage:
              </b>
              <span>
                {" "}
                You can also start investing in stocks by opening an individual
                retirement account (even in addition to having a workplace
                plan). Or, you can go with a regular, taxable brokerage account.
                Normally, you'll have lots of options for investing in stocks.
                These could include individual stocks, stock mutual funds and
                exchange traded funds (ETFs), stock options.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <b className="text-[1.75rem] font-dm-sans">
                A robo-advisor account:
              </b>
              <span>
                {" "}
                As referenced above, this type of account takes your investment
                goals and creates a stock portfolio for you.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>5. Learn to Diversify and Reduce Risk</span>
            </b>
          </p>
          <p className="m-0 text-[1.75rem] text-gainsboro-100">
            <span>
              <b>
                <span>&nbsp;</span>
              </b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                Diversification is an important investment concept to
                understand. In a nutshell, by investing in a range of assets, or
                diversifying, you reduce the risk that one investment’s
                performance can severely hurt the return of your overall
                investment portfolio. You could think of it as financial jargon
                for not putting all of your eggs in one basket.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                It can be difficult to diversify when investing in individual
                stocks if your budget is limited. For example, with just $1,000,
                you may only be able to invest in one or two companies. This
                results in greater risk.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                This is where mutual funds and ETFs can help. Both types of
                funds tend to own a large number of stocks and other
                investments. This makes them a more diversified option than a
                single stock.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Minimums to Open an Account</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                Many financial institutions have minimum deposit requirements.
                In other words, they won’t accept your account application
                unless you deposit a certain amount of money.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                It pays to shop around, and not just to find out minimum
                deposits. Check out our broker reviews (see below). Some firms
                don't require minimum deposits. Others may reduce costs, such as
                trading fees and account management fees if you have a balance
                above a certain threshold. Still others may offer a certain
                number of commission-free trades for opening an account.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-left text-[1.81rem]">
          <p className="m-0 text-[1.88rem]">
            <b>
              <span>
                <span>The Costs to Invest in Stocks</span>
              </span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>
                <span>&nbsp;</span>
              </b>
            </span>
          </p>
          <p className="m-0">
            <span>
              <b>
                <span>Commissions and Fees</span>
              </b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                As economists like to say, there's no free lunch. All brokers
                have to make money from their customers in one way or another.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                In most cases, your broker will charge a commission every time
                that you trade stocks, whether you buy or sell. Trading fees
                range from $2 per trade to as high as $10. Some brokers charge
                no trade commissions at all, but they make up for it with other
                fees.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Depending on how often you trade, these fees can add up, affect
                your portfolio's return, and deplete the amount of money you
                have to invest.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>Here's an example:</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Imagine that you decide to buy one share of stock in each of
                five companies with your $1,000. Assuming a transaction fee of
                $10, you will incur $50 in trading costs which is equivalent to
                five percent of your $1,000.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Should you sell these stocks, the round trip (the act of buying
                and then selling) would cost you a total of $100, or 10 percent
                of your initial deposit amount of $1,000. These costs alone can
                eat into your account balance before your investments even have
                a chance to earn a positive return.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <b>Mutual Fund Loads</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                Mutual funds are professionally managed pools of investor funds
                that focus their investments in different markets.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                They have various fees that you should be aware of. One of these
                is the management expense ratio (MER). The MER is the fee paid
                by shareholders of a mutual fund (or ETF) and goes toward the
                expenses of running a fund.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                It’s based on the total of a fund's assets under management. The
                MER can range from 0.05 percent to 2 percent annually. Bear in
                mind that, the higher the MER, the more it impacts the fund's
                overall return.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                You may also see sales charges called loads. These include
                front-end loads and back-end loads. Be sure you understand
                whether a fund carries a sales load prior to buying it. Check
                out your broker's list of no-load funds and no-transaction-fee
                funds to avoid these charges.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                For the beginning investor, mutual fund fees may be more
                palatable compared to the commissions charged when you buy
                individual stocks. Plus, you can invest less to get started with
                a fund than you’d probably pay to invest in individual stocks.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                By the way, investing small amounts consistently over time in a
                mutual fund can give you the benefits of dollar cost averaging
                (DCA) by reducing the impact of volatility.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Full-Service Brokers</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                Full-service brokers, as the name implies, offer a full range of
                traditional brokerage services, including financial advice for
                college planning, retirement planning, estate planning, and for
                other life events and opportunities. This custom-tailored advice
                justifies the higher fees that they typically charge, compared
                to other brokers. These can include a percentage of your
                transactions, a percentage of your assets under management, and
                sometimes, a yearly membership fee. Minimum account sizes can
                start at $25,000.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Discount Brokers</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                Discount brokers used to be the exception but are now the norm.
                They offer you tools to select your investments and place your
                orders. Some also offer a set-it-and-forget-it robo-advisory
                service (more below). Many provide educational materials on
                their sites and mobile apps, which can be helpful for beginning
                investors.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Some brokers have no (or very low) minimum deposit restrictions.
                However, they may have other requirements and fees. Be sure to
                check on both of these as you look for a brokerage account that
                meets your stock investing needs.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch flex flex-col items-center justify-center">
          <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b>
                <span>ALWAYS remember the five golden rules of investing:</span>
              </b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <ul className="m-0 text-[1rem] pl-[2.06rem]">
              <li className="mb-[1.4rem]">
                <span>
                  <span>
                    The greater return you want, the more risk you'll usually
                    have to accept.
                  </span>
                </span>
              </li>
              <li className="mb-[1.4rem]">
                <span>
                  <span>
                    Don't put all your eggs in one basket. Try to diversify as
                    much as you can to lower your risk exposure – in other
                    words, invest in different companies, industries and regions
                  </span>
                </span>
              </li>
              <li className="mb-[1.4rem]">
                <span>
                  <span>
                    If you're saving over the short term, it's wise not to take
                    too much of a risk. It's recommended you invest for at least
                    five years. If you can't, it's often best to steer clear of
                    investing and leave your money in a savings account.
                  </span>
                </span>
              </li>
              <li className="mb-[1.4rem]">
                <span>
                  <span>
                    Review your portfolio. A share might be a dud or you might
                    not be willing to take as many risks as you did before. If
                    you don't review your portfolio regularly, you could end up
                    with a share account which loses money.
                  </span>
                </span>
              </li>
              <li>
                <span>
                  <span>
                    Don't panic. Investments can go down as well as up. Don't be
                    tempted to sell or buy shares just because everyone else is.
                  </span>
                </span>
              </li>
            </ul>
          </div>
          <img
            className="relative w-[37.5rem] h-[37.5rem] object-cover"
            alt=""
            src="/i27@2x.png"
          />
        </div>
      </div>
      <a className="w-full mb-[6rem] rounded-32xl bg-gainsboro-200 box-border flex flex-row items-center justify-between py-[0.75rem] px-[0rem] max-w-[25rem] text-center text-[2.81rem] border-[1px] border-solid border-gray-300" 
      href="/lesson6">
        <div className="w-full">
        <b className="inline-block flex-1 w-full relative text-center pb-[0.8rem]">Next Chapter</b>
        </div>
      </a>
    </div>
  );
};

export default Lesson5;
